import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import CustomHeader from "../components/Header";
import { CardDeck, Row, Col, Container, Card, Button } from "react-bootstrap";
import Select from "react-select";
import axiosConfig from "../config/axiosConfig";
import Swal from 'sweetalert2/dist/sweetalert2.js';

const todayDate = new Date();

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected ? "black" : "black",
    backgroundColor: state.isSelected ? "#7367f0" : "white",
  }),
  control: (provided) => ({
    ...provided,
    borderRadius: "20px",
    borderColor: "#7367f0",
  }),
};

const firstDate = new Date();
const currentDate = new Date();
class ManualTransaction extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      Products: [],
      UserDetail: [],
      PANs: [],
      Outlets: [],

      PAN: 0,
      OdometerReading: '',
      Name: '',
      VRN: '',
      mindate: '',
      createdDate: '',
      ActivityDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), 2).toISOString().slice(0,16), //new Date(date.getFullYear(), date.getMonth(), 1);

      price: 0.0,
      TransactionAmount: 0.0,
      TransactionQuantity: 0.0,
      OutletId: 0,
      ProductCode: 0,
      subButtonEnabled:true,
    };

    this.changeHandler = this.changeHandler.bind(this);

    this.onClickSave = this.onClickSave.bind(this);
    this.onPANChange = this.onPANChange.bind(this);
    this.onOutletChange = this.onOutletChange.bind(this);
    this.onProductChange = this.onProductChange.bind(this);
    this.changeAmountHandler = this.changeAmountHandler.bind(this);
    this.changeQuantityHandler = this.changeQuantityHandler.bind(this);
    this.changeHandler_GetLastOdometerReading = this.changeHandler_GetLastOdometerReading.bind(this);
    this.changeHandlerDate = this.changeHandlerDate.bind(this);
    this.setTodayDate = this.setTodayDate.bind(this);
  }

  async setTodayDate() {


    let year = todayDate.getUTCFullYear()
    let month = todayDate.getUTCMonth() + 1;
    if (month < 10) { month = "0" + month }
    let day = todayDate.getDate()

    let _today = year + '-' + month + '-' + day;
    await this.setState({ mindate: _today });
  }


  componentDidMount() {

    Swal.fire({
      title: 'Please Wait ...',
      onBeforeOpen() {
          Swal.showLoading()
      },
      onAfterClose() {
          Swal.hideLoading()
      },
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false
  })
    this.setTodayDate();
    const data = {
      UserBranchID: this.props.data.selectedBranchId,
    };

    /*Get Outlets*/
    axiosConfig
      .post("Portal/GetOutlets")
      .then((res) => {

        for (var i = 0; i < res.data.outlets.length; i++) {
          this.setState((prevState) => ({

            Outlets: [
              ...prevState.Outlets,
              {
                value: res.data.outlets[i].outletID,
                label: res.data.outlets[i].outletName,
              },
            ],
          }));
        }
      })
      .catch(function (error) { });

    /*Get PANs*/
    this.setState({
      PANs: []
    });
    axiosConfig
      .post("Portal/GetPANs", data)
      .then((res) => {

        for (var i = 0; i < res.data.pans.length; i++) {
          this.setState((prevState) => ({

            PANs: [
              ...prevState.PANs,
              {
                value: res.data.pans[i].id,
                label: res.data.pans[i].pan,
                createdDate: res.data.pans[i].createdDate,
              },
            ],
          }));
        }
      })
      .catch(function (error) { })
      .finally(() => {
       // setLoading(false)
        Swal.close();
    });


  }

  changeAmountHandler(p) {
    var res = p.target.value / this.state.price;
    this.setState({ TransactionQuantity: res });
    var newState = {};
    newState[p.target.name] = p.target.value;
    this.setState(newState);


  }

  changeQuantityHandler(p) {
    var res = p.target.value * this.state.price;
    this.setState({ TransactionAmount: res });
    var newState = {};
    newState[p.target.name] = p.target.value;
    this.setState(newState);
  }

  changeHandler(p) {

    console.log('hello' + p.target.value)
    var newState = {};
    newState[p.target.name] = p.target.value;
    this.setState(newState);


  }
  changeHandlerDate(s) {
    let year = todayDate.getUTCFullYear()
    let month = todayDate.getUTCMonth() + 1;
    if (month < 10) { month = "0" + month }
    let day = todayDate.getDate()

    let _today = year + '-' + month + '-' + day

    var date1 = new Date(day);
    var date2 = new Date(s.target.value);

  }

  async changeHandler_GetLastOdometerReading(p) {
    const data = {
      UserBranchID: this.props.data.selectedBranchId,
      dateTime: p.target.value,
      MappingId: this.state.MappingId,
    };
    await this.setState({
      ActivityDate: p.target.value,

    });
    /*Get UserDetail*/
    this.setState({
      UserDetail: []
    });
    axiosConfig
      .post("Portal/GetUserDetail", data)
      .then((res) => {

        this.setState(
          {
            Name: res.data.name,
            VRN: res.data.vrn,
            OdometerReading: res.data.odo,
          }
        );
        this.setState({subButtonEnabled: false});
      })
      .catch(function (error) { });

  }


  onClickSave() {
    axiosConfig.post("Portal/AddManualTransaction",
      {
        UserBranchID: this.props.data.selectedBranchId,
        OutletId: this.state.OutletId,
        ProductCode: this.state.ProductCode,
        ActivityDateTime: this.state.ActivityDate,
        MappingId: this.state.MappingId,
        Amount: this.state.TransactionAmount,
        Quantity: this.state.TransactionQuantity,
        OdometerReading: this.state.OdometerReading,
        UserName: this.state.Name,
        Vrn: this.state.VRN,
        Price: this.state.price
      }
    )
      .then(Response => {
        Swal.fire({
          icon: 'success',
          title: 'Saved Successfully',
          confirmButtonText: 'Okay'
        })
        .then((result) => {
          if (result.isConfirmed) {
            localStorage.setItem('tabClosed', 'false');
            window.location.reload();
          }})
        })
          .catch(error => {
            Swal.fire({
              title: error.response.data.errorMessage,
              text: 'Some Error !',
              icon: 'error',
              confirmButtonText: 'Okay'
            })
          })
        // window.location.reload();
        /*End*/
      }


  async onPANChange(selectedOption) {
        this.setState({
          // OdometerReading: selectedOption.OdometerReading,
          // Name: selectedOption.value,
          // VRN: selectedOption.vrn,
          MappingId: selectedOption.value,
          createdDate: selectedOption.createdDate,
        });
      }

  async onOutletChange(selectedOption) {
        /*Get Products*/
        this.setState({
          Products: [],
          OutletId: selectedOption.value
        });
        axiosConfig.post("Portal/GetProducts",
          {
            OutletId: selectedOption.value,
          }
        )
          .then((res) => {
            for (var i = 0; i < res.data.product.length; i++) {
              this.setState((prevState) => ({

                Products: [
                  ...prevState.Products,
                  {
                    value: res.data.product[i].productCode,
                    label: res.data.product[i].name,
                    price: res.data.product[i].price,
                  },
                ],
              }));
            }
          })
          .catch(function (error) { });
      }


  async onProductChange(selectedOption) {
        this.setState({
          price: selectedOption.price,
          ProductCode: selectedOption.value
        });
      }

  render() {
        const { AvglastOdometerReadings, TransactionAmount, TransactionQuantity, Name, VRN } = this.state;
        const buttonStyle = {
          background: "#E0E0E0",
          width: 200,
          padding: 16,
          textAlign: "center",
          margin: "0 auto",
          marginTop: 32,
        };

        return(
      <>
        <CustomHeader></CustomHeader>
        <Row className="p-3">
          <Card className="p-3" style={{ width: "100%" }}>
            <Card.Title>
              <div className="pull-left">
                Manual Transaction
                <br></br>
              </div>
            </Card.Title>

            <Card.Body>
              <Row className="justify-content-center align-items-center">
                <div className="col-md-3 col-12">
                  <label className="font-weight-bold">Choose Outlet</label>
                </div>
                <div className="col-md-4 col-12">
                  <div className="form-label-group">
                    <Select
                      className=""
                      options={this.state.Outlets}
                      styles={customStyles}
                      onChange={this.onOutletChange}
                    ></Select>
                  </div>
                </div>
              </Row>
              <Row className="justify-content-center align-items-center">
                <div className="col-md-3 col-12">
                  <label className="font-weight-bold">Choose Product</label>
                </div>
                <div className="col-md-4 col-12">
                  <div className="form-label-group">
                    <Select
                      className=""
                      options={this.state.Products}
                      styles={customStyles}
                      onChange={this.onProductChange}
                    ></Select>
                  </div>
                </div>
              </Row>
              <Row className="justify-content-center align-items-center">
                <div className="col-md-3 col-12">
                  <label className="font-weight-bold">Choose PAN</label>
                </div>
                <div className="col-md-4 col-12">
                  <div className="form-label-group">
                    <Select
                      className=""
                      options={this.state.PANs}
                      styles={customStyles}
                      onChange={this.onPANChange}
                    ></Select>
                  </div>
                </div>
              </Row>
              
              <Row className="justify-content-center align-items-center">
                <div className="col-md-3 col-12">
                  <label className="font-weight-bold text-right">Pick date</label>
                </div>
                <div className="col-md-4 col-12">
                  <div className="form-label-group">
                    <input type="datetime-local" id="ActivityDate" name="ActivityDate" value={this.state.ActivityDate} onChange={this.changeHandler_GetLastOdometerReading} className="form-control" min={this.state.createdDate} />
                  </div>
                </div>
              </Row>
              <Row className="justify-content-center align-items-center">
                <div className="col-md-3 col-12">
                  <label className="font-weight-bold">Last Odometer Reading </label>
                </div>
                <div className="col-md-4 col-12">
                  <div className="form-label-group">
                    <input type="text" id="OdometerReading" name="OdometerReading" value={this.state.OdometerReading} onChange={this.changeHandler}  className="form-control" maxLength="7" readOnly />
                  </div>
                </div>
              </Row>
              <Row className="justify-content-center align-items-center">
                <div className="col-md-3 col-12">
                  <label className="font-weight-bold">Name </label>
                </div>
                <div className="col-md-4 col-12">
                  <div className="form-label-group">
                    <input type="text" id="Name" name="Name" value={this.state.Name} onChange={this.changeHandler}  className="form-control" maxLength="7" readOnly />
                  </div>
                </div>
              </Row>
              <Row className="justify-content-center align-items-center">
                <div className="col-md-3 col-12">
                  <label className="font-weight-bold">VRN </label>
                </div>
                <div className="col-md-4 col-12">
                  <div className="form-label-group">
                    <input type="text" id="VRN" name="VRN" value={this.state.VRN} onChange={this.changeHandler}  className="form-control" maxLength="7" readOnly />
                  </div>
                </div>
              </Row>
              <Row className="justify-content-center align-items-center">
                <div className="col-md-3 col-12">
                  <label className="font-weight-bold">Amount </label>
                </div>
                <div className="col-md-4 col-12">
                  <div className="form-label-group">
                    <input type="number" id="TransactionAmount" name="TransactionAmount" value={this.state.TransactionAmount} onChange={this.changeAmountHandler} className="form-control" />
                  </div>
                </div>
              </Row>
              <Row className="justify-content-center align-items-center">
                <div className="col-md-3 col-12">
                  <label className="font-weight-bold">Quantity</label>
                </div>
                <div className="col-md-4 col-12">
                  <div className="form-label-group">
                    <input type="number" id="TransactionQuantity" name="TransactionQuantity" value={this.state.TransactionQuantity} onChange={this.changeQuantityHandler} className="form-control" />
                  </div>
                </div>
              </Row>
              <div>
                <div class="pull-middle">
                  <div className="form-label-group">
                    <Button
                      className="btn-shell"
                      variant="warning"
                      onClick={this.onClickSave}
                      disabled={this.state.subButtonEnabled}
                    >
                      Save
                    </Button>
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Row>
      </>
    );
  }
}

export default ManualTransaction;
